import React, { useEffect } from "react";
import { Hero } from "./components/Hero";
import { TrustStrip } from "./components/TrustStrip";
import { Problems } from "./components/Problems";
import { Solution } from "./components/Solution";
import { MainContent } from "./components/MainContent";
import { SampleCarousel } from "./components/SampleCarousel";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Faq } from "./components/Faq";
import { Closing } from "./components/Closing";
import { Footer } from "./components/Footer";
import { MobileCtaBar } from "./components/MobileCtaBar";
import { initPixel } from "./utils/pixel";
import { pageTitle } from "./data/content";
export function App() {
  useEffect(() => {
    document.title = pageTitle;
    initPixel();
  }, []);
  return <div lang="fr" className="min-h-screen w-full overflow-x-hidden bg-ink pb-24 font-sans text-white antialiased md:pb-0" data-id="element-0" data-mp="28s31dk1f0dz5">
      <main data-id="element-1" data-mp="3ikhaeg9qb525">
        <Hero data-id="element-2" data-mp="3iiwdijzxza14" />
        <TrustStrip data-id="element-3" data-mp="3ij65gd4jrr9g" />
        <Problems data-id="element-4" data-mp="3ihv1odb3qjic" />
        <Solution data-id="element-5" data-mp="3mlj9mx3nbh44" />
        <MainContent data-id="element-6" data-mp="3ml1419v3fqjj" />
        <SampleCarousel data-id="element-7" data-mp="3mkho1yp07c85" />
        <Bonuses data-id="element-8" data-mp="3mjq2lgp4euvl" />
        <Offer data-id="element-9" data-mp="3mj6hxs835sdv" />
        <Guarantee data-id="element-10" data-mp="3rcj5s04xxv5k" />
        <Faq data-id="element-11" data-mp="3rbzlwdvqcwow" />
        <Closing data-id="element-12" data-mp="3rdatypw7kqlt" />
      </main>
      <Footer data-id="element-13" data-mp="3recf5n6xuth9" />
      <MobileCtaBar data-id="element-14" data-mp="3relwynhtxubv" />
    </div>;
}